export const COMPANY_NAME = "CIVIC VOICES INSTITUTE";
export const COMPANY_SHORT = "Civic Voices Institute";
export const COMPANY_INITIALS = "CVI";
export const COMPANY_ADDRESS_FULL = "1576 ADOLFO DR., SAN JOSE, CA 95131";
export const COMPANY_LOCATION = "San Jose, CA";
export const COMPANY_REGION = "San Jose, CA";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1576%20ADOLFO%20DR.%2C%20SAN%20JOSE%2C%20CA%2095131";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Focus", "value": "Writing, speaking, and debate education" },
  { "label": "Service Area", "value": "San Jose, CA" },
  { "label": "Entity Type", "value": "Nonprofit public benefit corporation" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "CIVIC VOICES INSTITUTE" },
  { "label": "City / State", "value": "San Jose, CA" },
  { "label": "Address", "value": "1576 ADOLFO DR., SAN JOSE, CA 95131" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Writing Practice", "body": "A public profile for programs that help students build clear, confident written communication." },
  { "icon": "✦", "title": "Public Speaking", "body": "The organization description highlights student confidence, presentation skills, and constructive civic voice." },
  { "icon": "✿", "title": "Debate Programs", "body": "Directory-safe language frames debate as a learning environment for reasoning, listening, and leadership." },
  { "icon": "❍", "title": "Civic Engagement", "body": "The site presents the public charitable purpose without naming private people or exposing sensitive identifiers." },
];
